module.exports = __webpack_public_path__ + "img/com.moji.MojiWeather.ed4d852a.png";